export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-ko-KR.4e1b1ff0.xlsx";